import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import Media from 'webutils/media/media'
import pickMedia from 'emun.on-demand/media/media-picker'
import ProductTemplate from 'emun.on-demand/lib/product-template'
import positionOverlay from 'emun.on-demand/templates/position-overlay-prompt'
import compositeImage from 'emun.on-demand/templates/composite-image-prompt'
import utils from 'webutils/services/util'
import modals from 'webmodals/modals'

const stateMap = {
    General: 'info-circle',
    Images: 'camera',
    Documents: 'paperclip',
};

class ProductTemplateEditorController {
    constructor() {
        basicController(this)
        const $ctrl = this;
        $ctrl.bus = new ServiceBus()
        $ctrl.stateMap = stateMap;
        $ctrl.state = Object.keys(stateMap)[0];

        console.debug('ProductTemplateEditorController', $ctrl);
    }
    $onInit() {
        const $ctrl = this;
        $ctrl.query = $ctrl.manager.query;
        $ctrl.navs = $ctrl.manager.navs;
        if(+$ctrl.productTemplateId){
            $ctrl.bus.send('QueryProductTemplates.json?Id=' + $ctrl.productTemplateId).then(response => {
                if(!response.data.results.length) return $ctrl.mutliView(`Template not found`);
                $ctrl.title = 'Edit Product Template...';
                $ctrl.manager.productTemplate = $ctrl.request = new ProductTemplate(response.data.results[0]);
            }, r => $ctrl.mutliView(`Template lookup error`));
        }else{
            $ctrl.title = 'Create Product Template...';
            $ctrl.manager.productTemplate = $ctrl.request = new ProductTemplate();
        }
    }

    copyDesignArea(area, index, event) {
        const $ctrl = this;
        let newArea = Object.assign({}, area);
        newArea.overlays = area.overlays.map(o => Object.assign({}, o, {euid: utils.uuid()}));
        newArea.underlays = area.underlays.map(o => Object.assign({}, o, {euid: utils.uuid()}));
        newArea.euid = utils.uuid();
        newArea.label = 'new design area ' + ($ctrl.request.areas.length + 1);
        $ctrl.request.areas.push(newArea);
        $ctrl.selectArea(newArea);
        event && event.stopPropagation();
        return newArea;
    }

    addDesignArea(){
        const $ctrl = this;
        let area = {
            euid: utils.uuid(),
            label: 'new design area ' + ($ctrl.request.areas.length + 1),
            overlays: [],
            underlays: []
        };
        $ctrl.request.areas.push(area);
        $ctrl.selectArea(area);
        return area;
    }

    removeDesignArea(area, index, event){
        const $ctrl = this;
        $ctrl.request.areas.splice(index, 1);
        $ctrl.selectArea($ctrl.request.areas[index-1]);
        event && event.stopPropagation();
    }

    setState(state, index){
        const $ctrl = this;
        $ctrl.state = state;
    }

    selectArea(area, index){
        const $ctrl = this;
        $ctrl.selectedArea = area;
        $ctrl.setState(area ? area.euid : Object.keys(stateMap)[0]);
    }

    addMedia(fieldName,$files){
        const $ctrl = this;
        if($files.length === 0 ) return;
        let req = {
            request: {
                realm: 'product/template/images',
                tags:{
                }
            },
            files: $files
        };

        return $ctrl.bus.upload('CreateMedia.json', req).then(
            res => {
                res.data.media.forEach(m => {
                    $ctrl.request[fieldName].push(new Media(m));
                });
            }, res => modals.alert(JSON.stringify(res),'Could not save media!'));
    }

    configureCompositeImage(media, convert){
        const $ctrl = this;
        let options = {
            media,
            img: media,
            image: media,
            convert,
            productTemplate: $ctrl.manager.productTemplate
        }
        console.log('configureCompositeImage', options);
        compositeImage(options).then(ci => {
            console.log('composite image configured', { options, ci});
        });
    }

    removeOverlay(array, index){
        const $ctrl = this;
        if (index > -1) {
            array.splice(index, 1);
        }
    }

    moveUp(array, $index){
        const $ctrl = this;
        utils.move(array, $index, $index - 1);
    }

    moveDown(array, $index){
        const $ctrl = this;
        utils.move(array, $index, $index + 1);
    }

    configureOverlay(area, overlay, isUnderlay){
        let options = {
            area,
            overlay,
            isUnderlay
        }
        console.log('configureOverlay', { area, options});
        positionOverlay(options).then(media => {
            console.log('overlay configured', { area, options, media});
        });
    }

    pickOverlay(area, isUnderlay){
        let imgType = isUnderlay === true ? '*' : 'png';

        let options = {
            pattern: 'image/' + imgType,
            accept: 'image/' + imgType,
            context: 'Overlay',
            realm: 'Overlay',
            tags:{
                //'$AreaId':[area.id || ''],
                Type:['Overlay']
            }
        };
        let overlays = area[isUnderlay === true ? 'underlays' : 'overlays']
        console.log('pickOverlay', { area, options});
        pickMedia(options).then(media => {
            media.forEach(overlay => {
                if(!area.width) area.width = overlay.width;
                if(!area.height) area.height = overlay.height;
                overlays.push({
                    media:overlay,
                    label: overlay.name || ('new #' + (overlays.length + 1)),
                    description: overlay.contentType,
                    width: overlay.width,
                    height: overlay.height,
                    x: 0,
                    y: 0,
                    isProductImage: true,
                    canDesign: true
                });
            })
        });
    }

    addOverlay(area, $files, isUnderlay){
        const $ctrl = this;
        let req = {
            request: {
                realm: 'Overlay',
                tags:{
                    '$AreaId':[area.id || ''],
                    Type:['Overlay']
                }
            },
            files: $files
        };        
        let overlays = area[isUnderlay === true ? 'underlays' : 'overlays']


        return $ctrl.bus.upload('CreateMedia.json', req).then(
            res => {
                res.data.media.forEach(overlay => {
                    if(!area.width) area.width = overlay.width;
                    if(!area.height) area.height = overlay.height;
                    overlays.push({
                        media:overlay,
                        label: overlay.name || ('new #' + (overlays.length + 1)),
                        description: overlay.contentType,
                        width: overlay.width,
                        height: overlay.height,
                        x: 0,
                        y: 0,
                        isProductImage: true,
                        canDesign: true
                    });
                })
            }, res => modals.alert(JSON.stringify(res),'Could not save media!'));
    }

    mutliView(msg) {
        msg && console.warn(msg);
        this.$state.transitionTo('od-product-templates.multi-view');
    }

    submit() {
        const $ctrl = this;
        let url = ($ctrl.request.id ? 'Upd' : 'Cre') + 'ateProductTemplate.json';
        let req = Object.assign({}, $ctrl.request);
        //for(let k in req.tags)
        //    req.tags[k] = JSON.stringify(req.tags[k]);
        $ctrl.bus.send(url, req).then(res => {
            $ctrl.onSaved({productTemplate:res.data});
            $ctrl.mutliView();
        });
    }
}

export default ProductTemplateEditorController;